const { analyticsEventBus, ANALYTICS_EVENTS } = require('../../events');
const { createCustomEventGA4 } = require('../models/customEventGA4');
const pushEvent = require('../pushEvent');

/* -------------------------------------------------------------------------- *\
 * NEWSLETTER EVENTS                                                          *
\* -------------------------------------------------------------------------- */

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.newsletterSubscribed,
    (location) => {
      pushEvent(
        createCustomEventGA4('newsletter', [
          ['action', 'subscribe'],
          ['location', location],
        ])
      );
    }
  );
}

module.exports = {
  subscribeToAnalyticsEvents,
};
